export default function () {
  if (this.$route.name === 'EditPlan') {
    this.loadPlan()
  }
}
